import { useEffect } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useAssinarAtividade = ({ dadosOs, dataAndamento, atividade, formik }) => {
  const {
    request: assinarRequest,
    data: assinarData,
    errors: assinarErrors,
    isLoading: assinarIsLoading,
  } = useApiClient();

  const assinarAtividade = () => {
    const parametros = {
      sequencialPedidoProrrogacao: dataAndamento?.sqPedidoProrrogacao,
      sequencialAtividade: atividade?.sequencialAtividade,
      sequencialAndamento:
        dataAndamento?.situacaoUltimoAndamento === "A" ? dataAndamento?.sequencialUltimoAndamento : 0,
      textoDocumento: formik.values.textoDocumento,
      siglaAtividade: atividade?.siglaAtividade,
      nomeAtividade: atividade?.nomeAtividade,
      sequencialOrdemServico: dadosOs.sequencial,
      sequencialAcaoFiscal: dadosOs.acaoFiscal,
      cpfRepresentante: formik.values.cpfRepresentante,
      nomeRepresentante: formik.values.nomeRepresentante,
      cargoRepresentante: formik.values.cargoRepresentante,
      nuPaginaEdital: formik.values.nuPaginaEdital,
      dataComunicado: formik.values.dataComunicado,
      codigoRastreio: formik.values.codigoRastreio,
    };

    assinarRequest(apiRoutes.fiscalizacao.prorrogacaoos.assinarAtividade, parametros);
  };

  useEffect(() => {
    if (assinarIsLoading) return;

    if (!assinarData && !assinarErrors) return;

    if (assinarData) {
      toast.success(assinarData.message);
      window.location.reload();
    }

    if (assinarErrors) {
      toast.error(assinarErrors.message);
    }
  }, [assinarData, assinarErrors, assinarIsLoading]);

  return { assinarIsLoading, assinarAtividade, assinarErrors };
};

export default useAssinarAtividade;
